/* Info Component in SeriesPage */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../styles/Callsheets.module.css";

const Info2 = () => {
  return (
    <div className='mb-5'>
    <Row className='mb-3'>
    <Col className={`px-3 pt-1 ${styles.SubTitle6 }`} md={{span: 10, offset: 1 }}>
    <h5 className={`text-center pb-2 ${styles.Red }`} >CREATIVE FLOW</h5> 
    <hr className={`mt-0`}/>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> The Creative work is done by Scene
      in the <span className={`${styles.Red}`}>Scenes Workspace</span> which includes Scene Breakdowns, Characters/BG pages, Shotlists and Workshops.
    </p>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> Use Scene Workshops to design and collaborate on Production 
    Items, adding them to the <span className={`${styles.Red}`}>Production Tracker</span>.
    </p>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> Create Scene Shotlists on each Scene page. Also the Storyboard 
    and optionally the Scene Script can be added.
    </p>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> Add Background details and Character Costume Numbers 
    to the Scene along with Shooting and Post information.
    </p>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> Use Moodboards, Indexcards and Indexshots 
    for <span className={`${styles.Red}`}>pre-visualization</span>, Moodboards being linked to Scenes, Locations 
    and Characters.
    </p>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> Use the <span className={`${styles.Red}`}>Characters</span> feature
    to hold all Character and Actor information and Costume images. 
    </p>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> Use the <span className={`${styles.Red}`}>Locations</span> features
    to hold all Location Filming information and Images. 
    </p>
    <p className='mt-2'><span className={`${styles.Red}`}>*</span> Use the Departments feature for Department issues and exchanges.
    </p>
    <hr />
    </Col>
    </Row>
    </div>
  )
}

export default Info2